import classNames from 'classnames';
import { Section } from '@farmersdog/corgi-x';
import { ExtendedText } from '../../components';
import { useShowHomepageRedesign } from 'src/hooks/useHomepageRedesign';
import { HomepageEndToEndRedesignTreatments } from 'src/abTesting';
import { olsHealthValueProps, olsValueProps, olsVetsValueProps } from './data';
import type { HeroIconItem } from 'src/pages/HomepageRedesign/types';

import styles from './HeroIconItemsDesktop.module.css';

const valuePropsMap: Partial<
  Record<HomepageEndToEndRedesignTreatments, HeroIconItem[]>
> = {
  [HomepageEndToEndRedesignTreatments.Ols]: olsValueProps,
  [HomepageEndToEndRedesignTreatments.OlsVets]: olsVetsValueProps,
  [HomepageEndToEndRedesignTreatments.OlsHealth]: olsHealthValueProps,
};

export const HeroIconItemsDesktop = () => {
  const {
    treatment,
    isOlsTreatment,
    isOlsVetsTreatment,
    isOlsHealthTreatment,
  } = useShowHomepageRedesign();
  const valueProps = valuePropsMap[treatment] ?? [];

  return (
    <Section
      as="div"
      className={classNames(styles.wrapper, {
        [styles.wrapperOlsVets]: isOlsVetsTreatment,
        [styles.wrapperOlsHealth]: isOlsHealthTreatment,
      })}
    >
      <div
        className={classNames(styles.container, {
          [styles.containerOlsVets]: isOlsVetsTreatment,
          [styles.containerOlsHealth]: isOlsHealthTreatment,
        })}
      >
        <div className={styles.itemsWrapper}>
          <div
            className={classNames(styles.itemsContainer, {
              [styles.itemsContainerOlsVets]: isOlsVetsTreatment,
              [styles.itemsContainerOlsHealth]: isOlsHealthTreatment,
            })}
          >
            {valueProps.map(item => (
              <div key={item.id} className={styles.item}>
                <item.icon
                  role="img"
                  aria-label={item.iconLabel}
                  className={styles.icon}
                />
                <ExtendedText
                  variant={isOlsTreatment ? 'heading-18' : 'heading-22'}
                  weight="semibold"
                  color="Kale3"
                >
                  {item.text}
                </ExtendedText>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};
